import type { Ref } from "vue";

import { useI18nCommonFe } from "@solvari/translations";
import { isEqual } from "@solvari/utils";

import { defineRule } from "@/lib/validation/rules/defineRule";

const is = defineRule(isEqual, (locale) => {
  const { tr } = useI18nCommonFe({ locale });
  return {
    name: "is",
    message: ({ messageParams }) =>
      tr("common_fe.validation.is", messageParams),
  };
});

const url = defineRule(
  (value: URL | number | string | null | undefined) => {
    if (!value || typeof value === "number") {
      return false;
    }
    try {
      const url = new URL(value);
      return url.protocol === "http:" || url.protocol === "https:";
    } catch (_error) {
      return false;
    }
  },
  (locale) => {
    const { tr } = useI18nCommonFe({ locale });
    return {
      name: "url",
      message: ({ messageParams }) =>
        tr("common_fe.validation.url", messageParams),
    };
  },
);

const serverSideRule = defineRule(
  (_value: unknown, params: Ref<string>) => !params.value,
  {
    name: "serverSide",
    message: ({ params }) => params.value,
  },
);

export { is, serverSideRule, url };
